import { api } from "./authService";

const subjectService = {
  // Alle Fächer abrufen
  getAllSubjects: async () => {
    try {
      const response = await api.get("/subjects");
      return response.data;
    } catch (error) {
      console.error("Error fetching subjects:", error);
      throw error;
    }
  },

  // Fach anhand ID abrufen
  getSubjectById: async (id) => {
    try {
      const response = await api.get(`/subjects/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching subject ${id}:`, error);
      throw error;
    }
  },

  // Fächer für ein bestimmtes Semester abrufen
  getSubjectsBySemester: async (semesterId) => {
    try {
      const response = await api.get(`/subjects/semester/${semesterId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching subjects for semester ${semesterId}:`, error);
      throw error;
    }
  },

  // Fächer für eine bestimmte Schule und Semester abrufen
  getSubjectsBySchoolAndSemester: async (schoolId, semesterId) => {
    try {
      const response = await api.get(`/subjects/school/${schoolId}/semester/${semesterId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching subjects for school ${schoolId}, semester ${semesterId}:`, error);
      throw error;
    }
  },

  // Fächer für eine bestimmte Klasse und Semester abrufen
  getSubjectsByClassAndSemester: async (classId, semesterId) => {
    try {
      const response = await api.get(`/subjects/class/${classId}/semester/${semesterId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching subjects for class ${classId}, semester ${semesterId}:`, error);
      throw error;
    }
  },

  // Fächer für eine bestimmte Schule, Klasse und Semester abrufen
  getSubjectsBySchoolClassSemester: async (schoolId, classId, semesterId) => {
    try {
      // Use the endpoint that filters subjects by school, class, and semester through enrollments
      const response = await api.get(`/subjects/school/${schoolId}/class/${classId}/semester/${semesterId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching subjects for school ${schoolId}, class ${classId}, semester ${semesterId}:`, error);
      throw error;
    }
  },

  // Neues Fach erstellen
  createSubject: async (subjectData) => {
    try {
      const response = await api.post("/subjects", subjectData);
      return response.data;
    } catch (error) {
      console.error("Error creating subject:", error);
      throw error;
    }
  },

  // Fach aktualisieren
  updateSubject: async (id, subjectData) => {
    try {
      const response = await api.put(`/subjects/${id}`, subjectData);
      return response.data;
    } catch (error) {
      console.error(`Error updating subject ${id}:`, error);
      throw error;
    }
  },

  // Fach löschen
  deleteSubject: async (id) => {
    try {
      await api.delete(`/subjects/${id}`);
    } catch (error) {
      console.error(`Error deleting subject ${id}:`, error);
      throw error;
    }
  },
};

export default subjectService;